export default __webpack_public_path__ + "86ac1e01234d1c6ddea0c8a1d3be3f18.svg";